import React from "react";
import LandingFooter from "../layout/Footer/LandingFooter";

const TermsAndConditions = () => {
  return (
    <div
      style={{
        backgroundColor: "#FFF8F5",
        minHeight: "100vh",
        color: "#0C1D36",
      }}
    >
      <div className="container py-5">
        <h1 className="fw-bold mb-4">Terms of Conditions</h1>

        <div className="mb-5">
          <h4 className="fw-semibold mb-3">1. Introduction</h4>
          <p style={{ color: "#6C757D" }}>
            Welcome to <strong>IDLBAY</strong> — a smart platform designed to
            simplify{" "}
            <strong>
              attendance management, salary processing, and payslip generation
            </strong>{" "}
            for modern businesses. These Terms of Service (“
            <strong>Terms</strong>”) govern your access to and use of our
            website, mobile application, and related services (“
            <strong>Services</strong>”).
          </p>
          <p style={{ color: "#6C757D" }}>
            By using IDLBAY, you agree to follow these Terms. Please read them
            carefully before you start using the platform. If you’re using
            IDLBAY on behalf of a company or organization, you confirm that you
            have the authority to agree to these Terms on its behalf.
          </p>
        </div>

        <div className="mb-5">
          <h4 className="fw-semibold mb-3">2. Your Account</h4>
          <p style={{ color: "#6C757D" }}>
            To access certain features, you’ll need to create an IDLBAY account
            with accurate and up-to-date information. You are responsible for
            keeping your login credentials secure and for all activities that
            occur under your account.
          </p>
          <p style={{ color: "#6C757D" }}>
            If you notice any unauthorized use or security breach, please inform
            us immediately at{" "}
            <a
              href="mailto:hr@idlbay.com"
              style={{ color: "#0C1D36", textDecoration: "underline" }}
            >
              hr@idlbay.com
            </a>
            .
          </p>
        </div>

        {/* Section 3 */}
        <div className="mb-5">
          <h4 className="fw-semibold mb-3">3. Using IDLBAY Responsibly</h4>
          <p style={{ color: "#6C757D" }}>
            IDLBAY helps businesses manage daily operations efficiently — from
            tracking employee attendance to generating accurate payslips. You
            agree to use the Services responsibly and for legitimate business
            purposes only.
          </p>
          <ul style={{ color: "#6C757D" }}>
            <li>
              Do not use the platform for fraudulent or illegal activities.
            </li>
            <li>
              Do not attempt to hack, modify, or disrupt our system’s normal
              operation.
            </li>
            <li>
              Only use IDLBAY to manage employees or organizations you are
              authorized to handle.
            </li>
          </ul>
          <p style={{ color: "#6C757D" }}>
            We reserve the right to suspend or terminate accounts that misuse
            the platform or violate these Terms.
          </p>
        </div>

        <div className="mb-5">
          <h4 className="fw-semibold mb-3">
            4. Subscriptions, Billing & Payments
          </h4>
          <p style={{ color: "#6C757D" }}>
            Access to premium IDLBAY features, such as salary automation,
            attendance analytics, and digital payslip generation, may require a
            paid subscription. Subscription plans, billing cycles, and pricing
            details are available on our website and may change with prior
            notice.
          </p>
          <p style={{ color: "#6C757D" }}>
            Subscriptions renew automatically unless canceled before the renewal
            date. Payments made are final and non-refundable, unless required by
            law or otherwise approved by us.
          </p>
        </div>

        {/* Section 5 */}
        <div className="mb-5">
          <h4 className="fw-semibold mb-3">
            5. Data Privacy & Confidentiality
          </h4>
          <p style={{ color: "#6C757D" }}>
            Your privacy matters. We protect your data as described in our{" "}
            <a
              href="#"
              style={{ color: "#0C1D36", textDecoration: "underline" }}
            >
              Privacy Policy
            </a>
            . IDLBAY uses industry-standard encryption and security practices to
            safeguard your company and employee information.
          </p>
          <p style={{ color: "#6C757D" }}>
            While we take every precaution, no online system can be 100% secure.
            We encourage you to keep your own secure backups of critical data.
          </p>
        </div>

        {/* Section 6 */}
        <div className="mb-5">
          <h4 className="fw-semibold mb-3">6. Payroll & Attendance Accuracy</h4>
          <p style={{ color: "#6C757D" }}>
            IDLBAY assists you in automating attendance tracking and payroll
            calculations. However, it’s your responsibility to:
          </p>
          <ul style={{ color: "#6C757D" }}>
            <li>
              Ensure all employee data and attendance records are accurate.
            </li>
            <li>Review and approve generated salary and payslip details.</li>
            <li>Comply with applicable labor and tax regulations.</li>
          </ul>
          <p style={{ color: "#6C757D" }}>
            We are not responsible for financial penalties or losses caused by
            inaccurate data input or legal non-compliance.
          </p>
        </div>

        {/* Section 7 */}
        <div className="mb-5">
          <h4 className="fw-semibold mb-3">7. Limitation of Liability</h4>
          <p style={{ color: "#6C757D" }}>
            To the maximum extent permitted by law, IDLBAY and its affiliates
            will not be liable for indirect or consequential losses — such as
            lost profits, data loss, or business interruptions — arising from
            the use or inability to use the Services.
          </p>
          <p style={{ color: "#6C757D" }}>
            Our total liability for any claim will not exceed the subscription
            fees paid by you during the three (3) months prior to the event.
          </p>
        </div>

        {/* Section 8 */}
        <div className="mb-5">
          <h4 className="fw-semibold mb-3">8. Intellectual Property</h4>
          <p style={{ color: "#6C757D" }}>
            All software, design, trademarks, and materials within IDLBAY belong
            exclusively to IDLBAY. You are granted a limited, non-transferable
            license to use the Services for internal business operations.
          </p>
          <p style={{ color: "#6C757D" }}>
            You may not copy, modify, reverse-engineer, or distribute any part
            of the platform without prior written permission.
          </p>
        </div>

        {/* Section 9 */}
        <div className="mb-5">
          <h4 className="fw-semibold mb-3">9. Updates to These Terms</h4>
          <p style={{ color: "#6C757D" }}>
            We may update these Terms occasionally to reflect improvements or
            legal changes. Updated versions will be posted on this page with a
            revised “Last Updated” date.
          </p>
          <p style={{ color: "#6C757D" }}>
            Continuing to use IDLBAY after changes means you accept the new
            Terms.
          </p>
        </div>

        {/* Section 11 */}
        <div>
          <h4 className="fw-semibold mb-3">11. Contact Us</h4>
          <p style={{ color: "#6C757D" }}>
            Have questions or need support? Reach out anytime:
          </p>
          <p style={{ color: "#6C757D" }}>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:hr@idlbay.com"
              style={{ color: "#0C1D36", textDecoration: "underline" }}
            >
              hr@idlbay.com
            </a>
            <br />
            <strong>Address:</strong> IDLBAY, Office No. 1, First Floor, Door
            No. 1, B. Narasimhan 3rd Street, T-Nagar, Chennai, Tamil Nadu –
            600017
          </p>
        </div>
      </div>
      <LandingFooter />
    </div>
  );
};

export default TermsAndConditions;
